export function textToSlug(title?: string, headingType?: string) {
  if (!title) return ''

  let slug = title
  if (headingType) slug = `${headingType}-${title}`

  return slug.toLowerCase().trim().replace(/\s+/g, '-')
}
